import styled from "styled-components";

export const PageNotFoundDiv = styled.div`
  text-align: center;
  display: flex;
  height: 80%;
  align-items: center;
  justify-content: center;

  .error {
    margin: auto;
    color: #5a5c69;
    font-size: 7rem;
    position: relative;
    line-height: 1;
    width: 12.5rem;

    .error {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: center;
    }

    .st0 {
      fill: #4c423b;
    }
    .st1 {
      opacity: 0.2;
    }
    .st2 {
      fill: #ffffff;
    }
    .st3 {
      fill: rgba(132, 121, 114, 0.4);
    }
    .st4 {
      fill: #424242;
    }
    .st5 {
      fill: #e0e0e0;
    }
    .st6 {
      fill: #bdbdbd;
    }
    .st7 {
      opacity: 0.64;
      fill: #212121;
    }
    .st8 {
      fill: #f5f5f5;
    }
    .st9 {
      opacity: 0.8;
      fill: #4c423b;
    }
  }
`;
